import { isQueryApiError } from "@features/errors/libs/guards";

/**
 * Остаток блокировки в секундах из ошибки ErrOtpResendBlocked.
 * Payload ошибки не типизирован (Record<string, unknown>).
 */
export const getResendBlockingTime = (error: unknown): null | number => {
  if (!isQueryApiError(error) || error.code !== "ErrOtpResendBlocked") {
    return null;
  }

  const { payload } = error;

  if (!payload || !("resendBlockingTime" in payload)) {
    return null;
  }

  const rawSeconds = payload.resendBlockingTime;

  if (typeof rawSeconds !== "string" && typeof rawSeconds !== "number") {
    return null;
  }

  const seconds =
    typeof rawSeconds === "number" ? rawSeconds : Number.parseFloat(rawSeconds);

  return Number.isFinite(seconds) ? seconds : null;
};
